<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="columns is-gapless center">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('ajoutDevis.table.editionContacts.title') }}
            </h1>
          </div>
        </div>
        <error-msg-component
            :messages="messages"
            :error="erreur"
            :title="'editionClient.problemOccurred'"
            @close="erreur = $event"/>
        <div class="columns mgt-20px">
          <div class="column is-12">
            <qd-button
              class="is-pulled-right"
              type="is-addOrEdit"
              @click="addContact">
                  {{$t('ajoutDevis.table.editionContacts.addContact')}}
            </qd-button>
          </div>
        </div>
        <div class="columns mgt-20px">
          <div class="column is-12">
            <v-client-table
              :data="allcontacts"
              :columns="columns"
              :options="options">
              <template slot="contactId" slot-scope="{ row, index }">
                <b-field
                  v-if="row.contact.id"
                  :message="row.contact.archive ?
                    $t('detailContact.warning.archivedContactSelectedAbove') : ''"
                  :type="row.contact.archive ? 'is-warning' : ''">
                  <span> {{ row.contact.nomPrenom }} </span>
                </b-field>
                <contact-autocomplete
                  v-if="!row.contact.id"
                  :tiers="intervenant.tiers"
                  :func-filter="c => allcontacts.every(ac => ac.contactId !== c.id)"
                  @added="selectAuto(index, $event)"
                  @input="updateContact(index, $event)"
                  withContactSuperieur/>
              </template>
              <template slot="contactTypes" slot-scope="{ row, index }">
                <qd-taginput
                  class="exception-input"
                  v-model="row.contactTypes"
                  :data="typeContacts.filter(t =>
                    !row.contactTypes.map(ct => ct.typeContactId).includes(t.typeContactId)
                  )"
                  type="is-primary"
                  open-on-focus
                  autocomplete
                  @input="updateValue(index, 'contactTypes', $event)"
                  field="libelle">
                  <template #tag="{ tag }">
                    {{ getTypeContact(tag.typeContactId) }}
                  </template>
                </qd-taginput>
              </template>
              <template slot="delete" slot-scope="{ index }">
                <a @click="deleteLine(index)">
                  <b-icon type="is-danger" icon="delete-forever" />
                </a>
              </template>
            </v-client-table>
          </div>
        </div>
        <div class="mgv-20px is-flex is-justify-content-flex-end">
          <div>
            <qd-button
              class="mg-2"
              type="is-addOrEdit"
              @click="editContact">
                {{$t('general.button.valider')}}
            </qd-button>
            <qd-button
              class="mg-2"
              @click="$parent.close">
                {{$t('general.button.cancel')}}
            </qd-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import ContactAutocomplete from '@/components/general/contactAutocomplete';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      allcontacts: [],
      erreur: false,
      messages: [],
    };
  },
  props: {
    intervenant: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    ContactAutocomplete,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    columns() {
      return ['contactId', 'contactTypes', 'delete'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          contactId: this.$t('ajoutDevis.table.editionContacts.tab.contact'),
          contactTypes: this.$t('ajoutDevis.table.editionContacts.tab.types'),
          delete: '',
        },
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        sortable: [],
        columnsClasses: {
          delete: 'colonneSelected has-text-centered',
          contactTypes: 'width-340',
          contactId: 'vertical-alignment',
        },
      };
    },
    typeContacts() {
      return this.parametre(PARAMETRES_KEYS.typeContact).map(t => {
        return {
          libelle: t.libelle,
          typeContactType: t.typeContactType,
          typeContactId: t.id,
        };
      });
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getTypeContact(typeContactId) {
      const typeContact = this.typeContacts.find((el) => typeContactId === el.typeContactId);
      return typeContact?.libelle || '';
    },
    selectAuto(index, contact) {
      contact.nomPrenom = [contact.nom, contact.prenom].filter(Boolean).join(' ');
      this.updateContact(index, contact);
    },
    addContact() {
      this.allcontacts.push({
        contact: { nomPrenom: '' },
        contactId: null,
        contactTypes: [],
      });
    },
    updateContact(index, value) {
      if (!value) return;
      delete value.client;
      this.$set(this.allcontacts[index - 1], 'contact', cloneDeep(value));
      this.$set(this.allcontacts[index - 1], 'contactId', cloneDeep(value.id));
      this.$set(this.allcontacts[index - 1], 'contactTypes', cloneDeep(value.typesContactIds?.map(tc => { return { typeContactId: tc }; }) ?? []));
    },
    updateValue(index, variable, value) {
      this.$set(this.allcontacts[index - 1], variable, value);
    },
    deleteLine(index) {
      this.allcontacts.splice(index - 1, 1);
    },
    editContact() {
      this.erreur = false;
      this.messages = [];
      this.allcontacts.forEach((c, index) => {
        if (!c.contact) {
          c.contact = this.contacts.find(ct => ct.id === c.contactId);
        }
        if (!c.contactId) {
          this.messages.push({ message: 'ajoutDevis.table.editionContacts.error.emptyline', parametres: { num: index + 1 } });
        }
      });
      if (this.messages.length === 0) {
        this.$set(this.intervenant, 'intervenantContacts', this.allcontacts);
        this.$parent.close();
      } else {
        this.erreur = true;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeContact]);
      this.allcontacts = cloneDeep(this.intervenant.intervenantContacts);
      if (this.allcontacts.length === 0) {
        this.addContact();
      } else {
        this.allcontacts.forEach(c => {
          if (c.contact) {
            c.contact.nomPrenom = `${c.contact.nom} ${c.contact.prenom}`;
          }
        });
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
